import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { useBuwlCKOContext } from '../../context/GlobalBuwlCkoAppContext';
import { BuwlSourceSystem, Language } from '../../model/IBuwlCKOContext';
import { useTranslation } from 'react-i18next';
import { PaymentType } from '../../model/Payment';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';

interface UAFopCardInfoProps {
    paymentType: PaymentType;
    setPaymentType: (paymentType: PaymentType) => void;
}

const UAFopCardInfoComponent: React.FC<UAFopCardInfoProps> = ({ paymentType, setPaymentType }) => {
    const { t, i18n } = useTranslation();
    const { buwlContext, updateContextValue } = useBuwlCKOContext();

    useEffect(() => {
        if (buwlContext && buwlContext.language) {
            const languageKey = buwlContext.language;
            i18n.changeLanguage(Language[languageKey].toLowerCase());
        }
    }, [buwlContext]);

    // Split the card number into groups for display
    const formatCardNumber = (number: string): string => {
        return number.match(/.{1,4}/g)?.join(' ') ?? '';
    };

    const handlePaymentTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPaymentType(event.target.value as PaymentType);
    };

    const FOP_CARD_NUMBER = '4035200041086510';
    /**
     * Одержувач
     * ФОП ФОП Призиглей Анастасія Орестівна
     * IBAN
     * UA463220010000026003310097880
     * ЄДРПОУ
     * 3618603064
     * Призначення платежу
     * Призначення платежу вказується згідно з актом виконаних робіт, інвойсом або контрактом.
     *
     * Реквізити Банку
     * Акціонерне Товариство УНІВЕРСАЛ БАНК
     * МФО 322001
     * ЄДРПОУ Банку 21133352
     */
    return (
        <div>
            <Typography variant="h5" gutterBottom>
                {t('payment')}
            </Typography>
            {buwlContext.sourceSystem == BuwlSourceSystem.BUWL_WEB_UA && (
                <RadioGroup value={paymentType} onChange={handlePaymentTypeChange}>
                    {Object.values(PaymentType).map((type) => (
                        <FormControlLabel value={type} control={<Radio color="default" />} label={t(type.valueOf())} />
                    ))}
                </RadioGroup>
            )}
            {paymentType == PaymentType.ADVANCE_PAYMENT && (
                <Typography variant="body2" sx={{ opacity: 0.6 }}>
                    {t('AdvancePaymentDetails')}
                </Typography>
            )}
        </div>
    );
};

export default UAFopCardInfoComponent;
